import { bootup } from "@app/bootup";
import { selectHasLabsFlagDetection } from "@app/organizations";
import { useSelector } from "@app/react";
import { homeUrl } from "@app/routes";
import { schema } from "@app/schema";
import { Navigate } from "react-router-dom";
import { AppSidebarLayout } from "../layouts";
import { Loading } from "../shared";
import { TitleBar } from "../shared/resource-list-view";

const TITLE_DESCRIPTION =
  "Preview in-progress Aptible features. Join a waitlist, or jump into features that have shipped.";

export const LabsPage = () => {
  const canSeeLabs = useSelector(selectHasLabsFlagDetection);
  const bootupLoader = useSelector((s) =>
    schema.loaders.selectById(s, { id: `${bootup}` }),
  );

  if (!bootupLoader.isSuccess) {
    return (
      <div className="flex w-full h-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (!canSeeLabs) {
    return <Navigate to={homeUrl()} replace />;
  }

  return (
    <AppSidebarLayout>
      <TitleBar description={TITLE_DESCRIPTION}>Labs</TitleBar>
    </AppSidebarLayout>
  );
};
